import cookie from 'js-cookie';
import {COOKIES} from './cookies';

export const getFromCookie = <T = string>(cookieName: COOKIES): T | undefined => {
  return (cookie.get(cookieName) as unknown) as T | undefined;
};
